import { createSelector } from 'reselect'
import { createCommunicationSelectors } from 'src/helpers/redux'
import { IState, PREFIX, TGlobalStateWithService } from './state'
import { actions } from './actions'

export const moduleStoreData = (
  state: TGlobalStateWithService
): IState['data'] => state[PREFIX]?.data

export const selectCommunication = (
  state: TGlobalStateWithService
): IState['communication'] => state[PREFIX].communication

export const communications = createCommunicationSelectors<
  TGlobalStateWithService,
  IState['communication'],
  typeof actions
>(selectCommunication, actions)

export const selectData = (state: TGlobalStateWithService): IState['data'] =>
  state[PREFIX]?.data

export const selectors = {
  threads: createSelector(moduleStoreData, (state) => state.threads),
  userMailAccounts: createSelector(
    moduleStoreData,
    (state) => state.userMailAccounts
  ),
  partnerMailAccounts: createSelector(
    moduleStoreData,
    (state) => state.partnerMailAccounts
  ),
  customLabels: createSelector(moduleStoreData, (state) => ({
    ...state.customLabels,
    data: state.customLabels.data.filter((l) => !l.isInternal),
  })),
  thread: createSelector(moduleStoreData, (state) => state.thread),
  assignLink: createSelector(moduleStoreData, (state) => state.assignLink),
}
